import React, { useState } from 'react';
import { Button, View } from "../../Components/Themed"
import { FlatList } from 'react-native';
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import ImageUploader from '../../Components/ImageUploader';
import ActionSelector from './components/ActionSelector';
import type { OrderProps } from '../../types';

type InputBarProps = {
    actions: string[],
    width:number,
    insets?:{ top:number, left:number, right:number, bottom:number },
    onImageUpload: (image: { url:string, [key:string]:any }) => void,
    onTagOrder?:(order:OrderProps) => void
}

const InputBar = ({ actions, insets, onImageUpload, onTagOrder } : InputBarProps) => {
    //const [ gif_select, setGifSelect ] = useState(false);

    const [ input_state, setInputState ] = useState<{
        action_selector_visible: boolean
    }>({
        action_selector_visible: false
    });
    const { action_selector_visible } = input_state

    const Colors = useColors();

    const renderActions = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'image':
                return (
                    <View style={{ margin:4, justifyContent:'center', alignItems:'center' }}>
                        <ImageUploader
                            public_id={(Math.random()*100000).toFixed()}
                            onFinishUpload={(obj) => onImageUpload({ ...obj, url: obj.secure_url })}
                        >
                            <Icons.ImageIcon size={16} color={Colors.text.action} />
                        </ImageUploader>
                    </View>
                )
            case 'action':
                return (
                    <Button style={{ justifyContent:'center', alignItems:'center', margin:4, padding:10 }} onPress={() => setInputState({ ...input_state, action_selector_visible:true })}>
                        <Icons.ActivityIcon size={18} color={Colors.text.action} />
                    </Button>
                )
            case 'gif':
                return (
                    <Button style={{ justifyContent:'center', alignItems:'center', margin:4, padding:10 }} onPress={() => console.log('')}>
                        <Icons.GIFIcon size={18} color={Colors.text.action} />
                    </Button>
                )
            default: return <></>
        }
    }



    return (
        <View transparent style={{ flexDirection:'row', alignItems:'center', padding:2 }}>
            <FlatList
                key={'action_list'}
                data={actions}
                horizontal
                keyExtractor={(item) => item}
                renderItem={renderActions}
            />
            <ActionSelector
                visible={action_selector_visible}
                insets={insets}
                onTagOrder={(order) => onTagOrder ? onTagOrder(order) : console.log('')}
                onClose={() => setInputState({ ...input_state, action_selector_visible: false })}
            />
        </View>
    )
}

export default InputBar